import React from 'react'
import { Button, Stack, Typography } from '@mui/material'
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined'
import { useTranslation } from '../../../../../common/hooks'

interface DoctorPatientDetailsHeaderProps {
  setActiveTabIndex: (tab: number) => void
}

export const DoctorPatientDetailsHeader: React.FC<
  React.PropsWithChildren<DoctorPatientDetailsHeaderProps>
> = ({ setActiveTabIndex }) => {
  const { t } = useTranslation()

  return (
    <Stack direction="row" alignItems="center" gap={1} height="24px">
      <Typography variant="body2" fontWeight="700">
        {t('patients:profileTitle')}
      </Typography>
      <Button
        sx={{ marginLeft: 'auto', padding: 0 }}
        variant="text"
        onClick={() => setActiveTabIndex(1)}
        endIcon={<ChevronRightOutlinedIcon />}
      >
        {t('patients:profileDetails')}
      </Button>
    </Stack>
  )
}
